import React from 'react';
import LegalPageLayout from './LegalPageLayout';

const TermsOfServicePage: React.FC = () => (
  <LegalPageLayout title="Terms of Service" updated="August 14, 2026">
    <p>
      These Terms of Service ("Terms") govern access to and use of Bilt websites, mobile applications, and related services
      operated by Tangents LLC ("Bilt", "we", "us"). By creating an account or using Bilt, you agree to these Terms and
      acknowledge the Privacy Policy.
    </p>
    <h2>1. Eligibility</h2>
    <p>
      Bilt is not directed to children under 13. You must be old enough under the laws of your jurisdiction to form a
      binding contract. Paid features, event registration, and certain organizer tools may require a higher age or
      capacity to contract. Final minimum-age policy is subject to legal review.
    </p>
    <h2>2. Accounts</h2>
    <p>
      You are responsible for account credentials, accurate profile information, and activity under your account. We may
      require email confirmation before higher-trust actions such as publishing sensitive content, paid registration,
      organizer tools, shop claims, or Passport reward claims when those gates are enabled.
    </p>
    <h2>3. Vehicle builds and user content</h2>
    <p>
      You retain ownership of content you upload (vehicle data, modifications, media, club and shop materials, and similar
      user-generated content). You grant Tangents LLC a worldwide, non-exclusive, royalty-free license to host, display,
      reproduce, and distribute that content as needed to operate and promote Bilt, including public build pages you choose
      to make public.
    </p>
    <h2>4. Accuracy and prohibited conduct</h2>
    <ul>
      <li>Do not post unlawful, infringing, deceptive, harassing, or fraudulent content.</li>
      <li>Do not impersonate shops, organizers, brands, or other people.</li>
      <li>Do not attempt to abuse Passport scans, rewards, sponsorship, or payment flows.</li>
      <li>Do not scrape, reverse engineer, or disrupt the service except as allowed by law.</li>
    </ul>
    <h2>5. Events, organizers, tickets, and payments</h2>
    <p>
      Event organizers are responsible for their event details, eligibility rules, and refund policies unless Bilt expressly
      states otherwise. Payments are processed by Stripe. Platform fees, payout timing, disputes, and chargebacks follow
      Stripe and organizer configurations. Bilt is not the organizer of third-party events unless we say so.
    </p>
    <h2>6. Clubs, shops, and contributors</h2>
    <p>
      Club and shop directories, membership decisions, and contributor attributions are subject to moderation. Claiming a shop
      or attributing work you did not perform may result in removal and account restrictions.
    </p>
    <h2>7. Passport, QR scanning, and rewards</h2>
    <p>
      Passport records encounters from QR collection and related signals according to your privacy settings. A static QR
      scan alone does not prove absolute physical presence or identity. Verification strength may vary (for example QR
      collected, event verified, proximity verified, or staff verified). Public counts and owner analytics reflect the
      verification levels actually recorded. Rewards, promotions, and sweepstakes require separate official rules and may
      remain disabled until legal gates are satisfied.
    </p>
    <h2>8. Intellectual property and copyright</h2>
    <p>
      Bilt branding, software, and platform materials are owned by Tangents LLC or its licensors. Copyright complaints are
      handled under our Copyright process. We do not claim to be a registered DMCA agent unless that registration is completed.
    </p>
    <h2>9. Third-party services</h2>
    <p>Bilt uses third parties such as Stripe, hosting providers, and optional email providers. Their terms also apply.</p>
    <h2>10. Disclaimers and liability</h2>
    <p>
      Bilt is provided "as is" to the extent permitted by law. Vehicle build information is user-generated and may be
      incomplete. Liability limitations, indemnification, governing law, and dispute resolution require attorney review
      before being treated as final.
    </p>
    <h2>11. Suspension, termination, and deletion</h2>
    <p>
      We may suspend or terminate accounts for Terms violations or risk to the platform. You may request account deletion
      in Settings. Some records may be retained for legal, payment, fraud, or safety reasons as described in the Privacy Policy.
    </p>
    <h2>12. Changes and contact</h2>
    <p>
      We may update these Terms. Material changes may require renewed acceptance. Contact: legal@biltspec.com (mailbox
      setup pending). Operated by Tangents LLC.
    </p>
  </LegalPageLayout>
);

export default TermsOfServicePage;
